import {useState, useEffect} from 'react';
import {Image} from 'react-bootstrap';
import {useParams} from 'react-router';
import ReactMarkdown from 'react-markdown';

import * as OralSupplierApi from '../api/OralSupplierApi';
import PageShell from '../components/PageShell';
import './OralSupplierContent.css';

export default function OralSupplierContent() {
  const {supplierId} = useParams();
  const [oralSupplier, setOralSupplier] = useState({});
  const [oralSupplierEssay, setOralSupplierEssay] = useState('');

  useEffect(() => {
    OralSupplierApi.getOralSupplier(supplierId).then((res) => {
      setOralSupplier(res);
    });
  }, [supplierId]);

  useEffect(() => {
    if (oralSupplier.content_markdown) {
      OralSupplierApi.getOralSupplierMarkdown(oralSupplier.content_markdown)
        .then((res) => {
          setOralSupplierEssay(res);
        })
        .catch((err) => {
          console.error('Failed to fetch markdown content:', err);
        });
    }
  }, [oralSupplier]);

  return (
    <PageShell title={oralSupplier.title} showBackButton={true}>
      <div className="padding-content">
        <Image src={oralSupplier.cover_image} alt="" style={{maxWidth: '100%', marginBottom: '1.5rem'}} />
        <ReactMarkdown>{oralSupplierEssay}</ReactMarkdown>
        <div className="supplier-buy">
          {/* Online ordering is not available yet: the button is inert and says why. */}
          <button
            type="button"
            className="melrose-btn supplier-buy-button"
            data-testid="supplier-buy-button"
            disabled
            aria-disabled="true"
            aria-describedby="supplier-coming-soon"
          >
            Buy
          </button>
          <p id="supplier-coming-soon" className="supplier-coming-soon" data-testid="supplier-coming-soon">
            Online ordering coming soon
          </p>
        </div>
      </div>
    </PageShell>
  );
}
